import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getBuyerRateContracts = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerRateContracts - error", error)
        return handleApiError(error)
    }
}

export const getBuyerRateContractByCompanyIdAndBranchId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/buyerRC`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerRateContractByCompanyIdAndBranchId - error", error)
        return handleApiError(error)
    }
}

export const getVMIBuyerRateContractByCompanyIdAndBranchId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/vmi/materials`, data);
        return await response.data;
    } catch (error) {
        console.log("getVMIBuyerRateContractByCompanyIdAndBranchId - error", error)
        return handleApiError(error)
    }
}

export const getBuyerRateContractDataById = async (buyerRateContractId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-rate-contract/${buyerRateContractId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerRateContractDataById - error", error)
        return handleApiError(error)
    }
}

export const insertBuyerRateContract = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBuyerRateContract - error", error)
        return handleApiError(error)
    }
}

export const insertBulkRateContractUploadSheet = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/bulkCreate`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBulkRateContractUploadSheet - error", error)
        return handleApiError(error)
    }
}

export const updateBulkRateContractPriceUploadSheet = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/bulk-update`, data);
        return await response.data;
    } catch (error) {
        console.log("updateBulkRateContractPriceUploadSheet - error", error)
        return handleApiError(error)
    }
}

export const getBuyerRateContractByValues = async (data) => {
    try {
        const res = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/buyerRateContract`, data);
        const result = await res.data;
        return result
    } catch (error) {
        return handleApiError(error)
    }
}

export const deleteBuyerRateContractById = async (buyerRateContractId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/delete/${buyerRateContractId}`);
        return await response.data;
    } catch (error) {
        console.log("deleteBuyerRateContractById - error", error)
        return handleApiError(error)
    }
}

export const updateBuyerRateContract = async (buyerRateContractId, data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/update/${buyerRateContractId}`, data)
        return await response.data
    } catch (error) {
        console.log("updateBuyerRateContract - error", error)
        return handleApiError(error)
    }
}

export const addRateContractRequirement = async(data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-rate-contract/requirement`, data)
        return await response.data
    } catch (error) {
        console.log("addRateContractRequirement - error", error)
        return handleApiError(error)
    }
}

export const getCompanyERPCodeSearch = async(data) => {
    try {
        const response = await axios.post(`https://portal.procmart.com/api/core/buyer-rate-contract/search/fuzzy`, data)
        return await response.data
    } catch (error) {
        console.log("getCompanyERPCodeSearch - error", error)
        return handleApiError(error)
    }
}

export const getFrequentlyBoughtItems = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-rate-contract/frequently_bought/${companyId}`)
        return await response.data
    } catch (error) {
        console.log("getFrequentlyBoughtItems - error", error)
        return handleApiError(error)
    }
 }

export const getRateContractUploadStatus = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-rate-contract/upload-status/${companyId}`)
        return await response.data
    } catch (error) {
        console.log("getRateContractUploadStatus - error", error)
        return handleApiError(error)
    }
}